<template>
    <div class="table-group-popover">
        <div class="group-row">
            <label>{{ $t("tables.groupField") }}</label>
            <a-select
                v-model="internalGroupField"
                :placeholder="$t('tables.groupField')"
                style="width: 100%"
            >
                <a-select-option
                    v-for="field in groupableFields"
                    :key="field._id"
                    :value="field._id"
                >
                    {{ field.name }}
                </a-select-option>
            </a-select>
        </div>
        <div class="group-row">
            <label>{{ $t("tables.sortDirection") }}</label>
            <a-select
                v-model="internalDirection"
                :placeholder="$t('tables.selectDirection')"
                style="width: 100%"
            >
                <a-select-option value="asc">{{ $t("tables.ascending") }}</a-select-option>
                <a-select-option value="desc">{{ $t("tables.descending") }}</a-select-option>
            </a-select>
        </div>
        <div class="group-row switch-row">
            <label>{{ $t("tables.showEmptyGroups") }}</label>
            <a-switch v-model="internalShowEmpty" />
        </div>
        <div class="group-actions">
            <a-button type="default" @click="onClearGroup">
                {{ $t("tables.clearGrouping") }}
            </a-button>
            <a-button type="primary" @click="onApplyGroup">
                {{ $t("tables.applyGrouping") }}
            </a-button>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import { Select, Switch, Button } from "ant-design-vue";

export default Vue.extend({
    name: "TableGroup",
    components: {
        "a-select": Select,
        "a-select-option": Select.Option,
        "a-switch": Switch,
        "a-button": Button,
    },
    props: {
        fields: {
            type: Array,
            required: true,
        },
        groupValue: {
            type: Object,
            default: function() {
                return {
                    fieldId: null,
                    direction: "asc",
                    showEmptyGroups: false
                };
            },
        },
    },
    data() {
        return {
            internalGroupField: this.groupValue.fieldId,
            internalDirection: this.groupValue.direction,
            internalShowEmpty: this.groupValue.showEmptyGroups
        };
    },
    computed: {
        // Burada hangi field'ların gruplamaya uygun olduğunu belirliyoruz.
        // Sayısal veya karmaşık tipleri hariç tutabilirsiniz.
        groupableFields() {
            return this.fields.filter(function(field) {
                // Örnek olarak tarih, dropdown (option) ve text tipleri
                // gruplamaya uygun olsun. 
                // Sayısal değerleri (number, currency vb.) hariç tutalım.
                if (
                    field.fieldType === "datetime" ||
                    field.fieldType === "dropdown" ||
                    field.fieldType === "text" ||
                    field.fieldType === "long-text" ||
                    field.fieldType === "email" ||
                    field.fieldType === "url" ||
                    field.fieldType === "phone"
                ) {
                    return true;
                }
                return false;
            });
        },
    },
    methods: {
        onApplyGroup() {
            var newGroup = {
                fieldId: this.internalGroupField,
                direction: this.internalDirection,
                showEmptyGroups: this.internalShowEmpty
            };
            // Üst bileşene güncel grouping ayarını ilet
            this.$emit("update-group", newGroup);
        },
        onClearGroup() {
            this.internalGroupField = null;
            this.internalDirection = "asc";
            this.internalShowEmpty = false;
            this.$emit("update-group", {
                fieldId: null,
                direction: "asc",
                showEmptyGroups: false
            });
        },
    },
});
</script>

<style scoped lang="scss">
.table-group-popover {
    width: max-content;
    padding: 10px;
    .group-row {
        margin-bottom: 12px;
        label {
            display: block;
            margin-bottom: 4px;
            font-weight: 500;
        }
    }
    .switch-row {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .group-actions {
        display: flex;
        justify-content: space-between;
    }
}
</style>
